import { Card, Col } from "reactstrap";
import InformationCommon from "./common/InformationCommon";
import { H4, Image, LI, P, UL } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { SearchDesc } from "../../../Constant";
import { SEARCH_INFORMATION, SEARCH_INFORMATION_TWO } from "../../../Data/SearchResult";

const SearchBanner = () => {
  return (
    <Col xxl="4" xl="6" className="box-col-5 mt-4">
      <Card className="o-hidden">
        <div className="blog-box blog-shadow">
          <Image className="img-fluid" src={dynamicImage("blog/blog.jpg")} alt="blog"/>
          <div className="blog-details">
            <P>25 July 2023</P>
            <H4>{SearchDesc}</H4>
            <UL className="blog-social simple-list d-flex flex-row">
              <LI><i className="icofont icofont-user"></i>Mark Jecno</LI>
              <LI><i className="icofont icofont-thumbs-up"></i>02 Hits</LI>
            </UL>
          </div>
        </div>
      </Card>
      <InformationCommon item={SEARCH_INFORMATION}  />
      <InformationCommon item={SEARCH_INFORMATION_TWO}  />
    </Col>
  );
};

export default SearchBanner;
